export default __webpack_public_path__ + "static/media/aplikasi-mobile.503c203e.jpg";